/**
 * @generated SignedSource<<8de49b1d5594786a6ef1200e390b9bb8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type tableBody_nativeIssueTable_rankField$data = {
  readonly fieldId: string | null | undefined;
  readonly jqlTerm: string;
  readonly " $fragmentSpreads": FragmentRefs<"renderChildRows_nativeIssueTable_RenderChildRowsComp">;
  readonly " $fragmentType": "tableBody_nativeIssueTable_rankField";
};
export type tableBody_nativeIssueTable_rankField$key = {
  readonly " $data"?: tableBody_nativeIssueTable_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"tableBody_nativeIssueTable_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "tableBody_nativeIssueTable_rankField",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "jqlTerm"
    },
    {
      "kind": "FragmentSpread",
      "name": "renderChildRows_nativeIssueTable_RenderChildRowsComp"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "8b693c9ea795101726e8ad64683d3168";

export default node;
